<tcc-simplePanel [size]="panalSize" [buttons]="['close']" (buttonClick)="close()">

    <div panel-header *ngIf="state === 'ready'">
        <div *ngIf="addOrEdit === 'add'">Add</div>
        <div *ngIf="addOrEdit === 'edit'">Edit {{currentPositionType?.name}}</div>
    </div>

    <div panel-body *ngIf="state === 'ready'">
        <div class="container">
            <div class="row">
                <div class="col-12" style="text-align: center;">
                    <h4>Position Type</h4>
                </div>
            </div>           

            <form [formGroup]="positionTypesFormGroup" (ngSubmit)="onSubmit()">

                <input type="number" 
                        formControlName="positionTypeId"                
                        #positionTypeId 
                        hidden>
                
                <label for="name">Name: </label>
                <input type="text" 
                       formControlName="name"
                       style="text-transform: uppercase;"
                       [ngClass]="{changed: isChanged('name')}"
                       name="name"
                       #name>
                <span *ngIf="duplicateKey && addOrEdit === 'add'" style="color:red">Duplicate Key</span>
                <br />
                <br />
      
                <label for="isService">Is Service: </label>
                <select formControlName="isService"
                        [ngClass]="{changed: isChanged('isService')}"
                        name="isService"
                        #isHidden>
                        <option [ngValue]="true">True</option>
                        <option [ngValue]="false">False</option>
                </select>
        
                <div style="margin-top: 10px;">
                    <button type="submit" [disabled]="!positionTypesFormGroup.valid || 
                                                      !positionTypesFormGroup.dirty || 
                                                      (duplicateKey && addOrEdit === 'add')">Save</button>
                </div>
            </form>
        </div>
    </div>

</tcc-simplePanel>
<tcc-loadingOverlay *ngIf="state !== 'ready'"></tcc-loadingOverlay>
